import React from "react";
import { Outlet, useLoaderData } from "react-router-dom";
import {
  AppLayout,
  TopNavigation,
  SideNavigation,
  SideActions,
} from "~/components";
import { useMediaQuery } from "@mui/material";
import * as APITypes from "~/API";
import { TourProvider, TourManager } from "~/components/Tour";
import {
  AppGuideProvider,
  AppGuideModal,
  TOTAL_SECTIONS,
} from "~/components/AppGuide";
import { RoutePendingUI } from "~/components/Layout/RoutePendingUI";
import { PageFallbackOutlet } from "~/components/Layout/PageFallbackOutlet";

export interface FirestoreUserProfileDisplay {
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  profilePictureUrl?: string;
}

export interface MainLayoutLoaderData {
  user: any;
  ownerID: string;
  ownerType: APITypes.OwnerType | null;
  role: APITypes.ManagerRolesType | null;
  profile: FirestoreUserProfileDisplay | null;
  isAuthenticated: boolean;
  error?: string;
}

/**
 * Unified app shell for public and authenticated routes.
 * Auth for restricted pages is enforced by requireAuthenticatedLoader on child routes.
 */
export const MainLayout: React.FC = () => {
  const loaderData = useLoaderData() as MainLayoutLoaderData;

  const smallScreen = useMediaQuery("(max-width: 465px)");

  const pageStyling = {
    flex: 1,
    padding: smallScreen ? "0.5rem" : "2rem",
  };

  const userHasOrganization =
    loaderData.isAuthenticated &&
    loaderData.ownerType === APITypes.OwnerType.Organization;

  return (
    <AppGuideProvider totalSections={TOTAL_SECTIONS}>
      <TourProvider>
        <TourManager />
        <AppGuideModal />
        <AppLayout
          TopNavigation={<TopNavigation />}
          SideNavigation={
            <SideNavigation userHasOrganization={userHasOrganization} />
          }
          SideAction={<SideActions />}
          PageContent={
            <div style={pageStyling}>
              <RoutePendingUI>
                <PageFallbackOutlet />
              </RoutePendingUI>
            </div>
          }
        />
      </TourProvider>
    </AppGuideProvider>
  );
};
